/**
 * Meldingen-voorkeuren per gebruiker (engine: /api/v1/voorkeuren/<sleutel>).
 * Eerste instelling: verslag + actiepunten na een EXTERNE opgenomen meeting.
 */
import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Switch, FormControlLabel, Alert, CircularProgress } from '@mui/material';
import { AI_ENGINE_URL } from '../../utils/apiConfig';
import { authFetch } from '../../utils/authHelpers';

const URL = `${AI_ENGINE_URL}/api/v1/voorkeuren/meeting_notificaties`;

export default function MeldingenPanel() {
  const [aan, setAan] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await authFetch(URL);
        const d = await r.json();
        if (!r.ok) throw new Error(d.detail || 'Voorkeur laden mislukt');
        setAan(d.aan !== false);
      } catch (e) { setError(e.message); setAan(true); }
    })();
  }, []);

  const zet = async (waarde) => {
    setBusy(true); setError(null); setMsg(null);
    const vorige = aan;
    setAan(waarde);
    try {
      const r = await authFetch(URL, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ aan: waarde }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Opslaan mislukt');
      setAan(d.aan !== false);
      setMsg(d.aan !== false ? 'Aan: je krijgt na een externe meeting een mail en een melding.' : 'Uit: je krijgt geen mail en geen melding meer na externe meetings.');
    } catch (e) { setError(e.message); setAan(vorige); }
    finally { setBusy(false); }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
      <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 0.5 }}>Verslag na een externe meeting</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Neem je een meeting op waar een klant, leverancier of freelancer voor uitgenodigd was, dan krijg je zodra het
        verslag klaar is een mail én een melding in het belletje, met de samenvatting, de actiepunten en een link naar
        het verslag. Interne meetings krijgen dit niet.
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 1.5 }} onClose={() => setError(null)}>{error}</Alert>}
      {msg && <Alert severity="success" sx={{ mb: 1.5 }} onClose={() => setMsg(null)}>{msg}</Alert>}
      {aan === null ? <CircularProgress size={18} /> : (
        <Box>
          <FormControlLabel control={<Switch checked={aan} onChange={(e) => zet(e.target.checked)} disabled={busy} />}
            label={aan ? 'Aan — mail en melding na externe meetings' : 'Uit — geen mail en geen melding'} />
        </Box>
      )}
    </Paper>
  );
}
